import vieLogo from './vieLogo.png';

import iphone from './iphone.png';

import mac from './mac.png';

import websiteProject from './website-project.png';

import mobileProject from './mobile-project.png';

import BlockChain from './block-chain.png';

import sale from './sale.png';

import videoCall from './video-call.mov';

import mobileEcomerce from './mobi-ecomerce.png';
import fulfill from './fulfill.png';

import slide1 from './mobileslide1.png';

import slide2 from './mobileslide2.png';
import slide3 from './mobileslide3.png';
import slide4 from './mobileslide4.png';

const Zaloicon = () => (
  <svg
    width="24"
    height="10"
    viewBox="0 0 24 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.49 3.27201V2.82201H13.837V9.14401H13.067C12.9146 9.14427 12.7683 9.08412 12.6601 8.97672C12.552 8.86932 12.4908 8.72343 12.49 8.57101V8.57201C11.9277 8.9836 11.2488 9.20501 10.552 9.20401C9.68138 9.20401 8.84638 8.85829 8.23057 8.24285C7.61476 7.62742 7.26853 6.79263 7.268 5.92201C7.26853 5.05138 7.61476 4.2166 8.23057 3.60116C8.84638 2.98573 9.68138 2.64001 10.552 2.64001C11.2485 2.63922 11.927 2.86062 12.489 3.27201H12.49ZM6.919 0.790009V0.995008C6.919 1.37701 6.868 1.68901 6.619 2.05501L6.589 2.08901C6.50604 2.18204 6.42535 2.27707 6.347 2.37401L2.024 7.80001H6.919V8.56801C6.919 8.64373 6.90407 8.71872 6.87506 8.78867C6.84605 8.85861 6.80353 8.92216 6.74994 8.97566C6.69635 9.02916 6.63273 9.07156 6.56273 9.10045C6.49273 9.12934 6.41773 9.14414 6.342 9.14401H0V8.78201C0 8.33901 0.11 8.14101 0.25 7.93501L4.857 2.23001H0.192V0.790009H6.92H6.919ZM15.47 9.14401C15.3427 9.14401 15.2206 9.09344 15.1306 9.00342C15.0406 8.9134 14.99 8.79131 14.99 8.66401V0.790009H16.431V9.14401H15.47ZM20.693 2.60001C21.1272 2.59988 21.5571 2.68526 21.9582 2.85128C22.3594 3.0173 22.7239 3.26071 23.031 3.56761C23.3381 3.8745 23.5817 4.23888 23.748 4.63993C23.9142 5.04099 23.9999 5.47086 24 5.90501C24.0001 6.33916 23.9147 6.76908 23.7487 7.17024C23.5827 7.57139 23.3393 7.93591 23.0324 8.243C22.7255 8.55008 22.3611 8.79371 21.9601 8.95997C21.559 9.12624 21.1292 9.21188 20.695 9.21201C19.8182 9.21227 18.9772 8.86422 18.357 8.24441C17.7368 7.6246 17.3883 6.78381 17.388 5.90701C17.3877 5.0302 17.7358 4.1892 18.3556 3.56902C18.9754 2.94884 19.8162 2.60027 20.693 2.60001ZM10.553 7.85301C10.8103 7.85886 11.0663 7.81324 11.3057 7.7188C11.5452 7.62436 11.7634 7.48303 11.9475 7.30309C12.1315 7.12316 12.2778 6.90825 12.3777 6.67099C12.4775 6.43374 12.529 6.17892 12.529 5.92151C12.529 5.6641 12.4775 5.40928 12.3777 5.17202C12.2778 4.93477 12.1315 4.71986 11.9475 4.53993C11.7634 4.35999 11.5452 4.21865 11.3057 4.12422C11.0663 4.02978 10.8103 3.98415 10.553 3.99001C10.0483 4.00149 9.56822 4.21003 9.21537 4.57101C8.86251 4.93198 8.66495 5.41672 8.66495 5.92151C8.66495 6.4263 8.86251 6.91103 9.21537 7.27201C9.56822 7.63299 10.0483 7.84152 10.553 7.85301ZM20.693 7.85001C21.2088 7.85001 21.7036 7.64509 22.0683 7.28033C22.4331 6.91557 22.638 6.42085 22.638 5.90501C22.638 5.38916 22.4331 4.89444 22.0683 4.52969C21.7036 4.16493 21.2088 3.96001 20.693 3.96001C20.1772 3.96001 19.6824 4.16493 19.3177 4.52969C18.9529 4.89444 18.748 5.38916 18.748 5.90501C18.748 6.42085 18.9529 6.91557 19.3177 7.28033C19.6824 7.64509 20.1772 7.85001 20.693 7.85001Z"
      fill="currentColor"
    />
  </svg>
);

const Facebookicon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0005 10.0615C20.0005 4.50399 15.523 -0.00100708 10.0005 -0.00100708C4.47549 0.00024292 -0.00201416 4.50399 -0.00201416 10.0627C-0.00201416 15.084 3.65549 19.2465 8.43549 20.0015V12.9702H5.89799V10.0627H8.43799V7.84399C8.43799 5.32274 9.93174 3.93024 12.2155 3.93024C13.3105 3.93024 14.4542 4.12649 14.4542 4.12649V6.60149H13.193C11.9517 6.60149 11.5642 7.37774 11.5642 8.17399V10.0615H14.3367L13.8942 12.969H11.563V20.0002C16.343 19.2452 20.0005 15.0827 20.0005 10.0615Z"
      fill="currentColor"
    />
  </svg>
);
const Tiktokicon = () => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.92035 0.0160313C9.95645 0 10.9866 0.0095 12.0156 0C12.0779 1.21184 12.5137 2.44625 13.4008 3.30303C14.2861 4.18119 15.5383 4.58316 16.7567 4.71912V7.90697C15.6149 7.86956 14.4678 7.63206 13.4317 7.14044C12.9804 6.93619 12.56 6.67316 12.1486 6.40419C12.1432 8.71744 12.1581 11.0277 12.1337 13.3315C12.072 14.4382 11.7068 15.5396 11.0632 16.4516C10.0277 17.9698 8.23041 18.9596 6.38445 18.9905C5.25216 19.0552 4.12107 18.7465 3.15623 18.1777C1.55726 17.2348 0.432102 15.5087 0.268227 13.6562C0.247585 13.2639 0.244415 12.8709 0.258727 12.4783C0.401227 10.9719 1.14638 9.53088 2.30301 8.55059C3.61401 7.40881 5.45048 6.86494 7.16998 7.18675C7.18601 8.35941 7.1391 9.53088 7.1391 10.7035C6.35357 10.4494 5.43563 10.5207 4.74926 10.9974C4.24709 11.3283 3.8676 11.815 3.66923 12.3827C3.50535 12.784 3.55226 13.2299 3.56176 13.6562C3.74998 14.9554 4.99923 16.0473 6.33279 15.9291C7.21688 15.9196 8.06416 15.4066 8.52491 14.6555C8.67395 14.3925 8.84079 14.1235 8.8497 13.8142C8.92748 12.3981 8.8966 10.9879 8.9061 9.57184C8.91263 6.38044 8.8966 3.19794 8.92095 0.016625L8.92035 0.0160313Z"
      fill="currentColor"
    />
  </svg>
);
const Instaicon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.465 0.066C7.638 0.012 8.012 0 11 0C13.988 0 14.362 0.013 15.534 0.066C16.706 0.119 17.506 0.306 18.206 0.577C18.939 0.854 19.604 1.287 20.154 1.847C20.714 2.396 21.146 3.06 21.422 3.794C21.694 4.494 21.88 5.294 21.934 6.464C21.988 7.639 22 8.013 22 11C22 13.988 21.987 14.362 21.934 15.535C21.881 16.705 21.694 17.505 21.422 18.205C21.146 18.9391 20.7133 19.6042 20.154 20.154C19.604 20.714 18.939 21.146 18.206 21.422C17.506 21.694 16.706 21.88 15.536 21.934C14.362 21.988 13.988 22 11 22C8.012 22 7.638 21.987 6.465 21.934C5.295 21.881 4.495 21.694 3.795 21.422C3.06092 21.146 2.39582 20.7133 1.846 20.154C1.28638 19.6047 0.853315 18.9399 0.577 18.206C0.306 17.506 0.12 16.706 0.066 15.536C0.012 14.361 0 13.987 0 11C0 8.012 0.013 7.638 0.066 6.466C0.119 5.294 0.306 4.494 0.577 3.794C0.853723 3.06008 1.28712 2.39531 1.847 1.846C2.39604 1.2865 3.06047 0.853443 3.794 0.577C4.494 0.306 5.294 0.12 6.464 0.066H6.465ZM15.445 2.046C14.285 1.993 13.937 1.982 11 1.982C8.063 1.982 7.715 1.993 6.555 2.046C5.482 2.095 4.9 2.274 4.512 2.425C3.999 2.625 3.632 2.862 3.247 3.247C2.88205 3.60205 2.60118 4.03428 2.425 4.512C2.274 4.9 2.095 5.482 2.046 6.555C1.993 7.715 1.982 8.063 1.982 11C1.982 13.937 1.993 14.285 2.046 15.445C2.095 16.518 2.274 17.1 2.425 17.488C2.601 17.965 2.882 18.398 3.247 18.753C3.602 19.118 4.035 19.399 4.512 19.575C4.9 19.726 5.482 19.905 6.555 19.954C7.715 20.007 8.062 20.018 11 20.018C13.938 20.018 14.285 20.007 15.445 19.954C16.518 19.905 17.1 19.726 17.488 19.575C18.001 19.375 18.368 19.138 18.753 18.753C19.118 18.398 19.399 17.965 19.575 17.488C19.726 17.1 19.905 16.518 19.954 15.445C20.007 14.285 20.018 13.937 20.018 11C20.018 8.063 20.007 7.715 19.954 6.555C19.905 5.482 19.726 4.9 19.575 4.512C19.375 3.999 19.138 3.632 18.753 3.247C18.3979 2.88207 17.9657 2.60121 17.488 2.425C17.1 2.274 16.518 2.095 15.445 2.046ZM9.595 14.391C10.3797 14.7176 11.2534 14.7617 12.0669 14.5157C12.8805 14.2697 13.5834 13.7489 14.0556 13.0422C14.5278 12.3356 14.7401 11.4869 14.656 10.6411C14.572 9.79534 14.197 9.00497 13.595 8.405C13.2112 8.02148 12.7472 7.72781 12.2363 7.54515C11.7255 7.36248 11.1804 7.29536 10.6405 7.34862C10.1006 7.40187 9.57915 7.57418 9.1138 7.85313C8.64845 8.13208 8.25074 8.51074 7.9493 8.96185C7.64786 9.41296 7.45019 9.92529 7.37052 10.462C7.29084 10.9986 7.33115 11.5463 7.48854 12.0655C7.64593 12.5847 7.91648 13.0626 8.28072 13.4647C8.64496 13.8668 9.09382 14.1832 9.595 14.391ZM7.002 7.002C7.52702 6.47697 8.15032 6.0605 8.8363 5.77636C9.52228 5.49222 10.2575 5.34597 11 5.34597C11.7425 5.34597 12.4777 5.49222 13.1637 5.77636C13.8497 6.0605 14.473 6.47697 14.998 7.002C15.523 7.52702 15.9395 8.15032 16.2236 8.8363C16.5078 9.52228 16.654 10.2575 16.654 11C16.654 11.7425 16.5078 12.4777 16.2236 13.1637C15.9395 13.8497 15.523 14.473 14.998 14.998C13.9377 16.0583 12.4995 16.654 11 16.654C9.50046 16.654 8.06234 16.0583 7.002 14.998C5.94166 13.9377 5.34597 12.4995 5.34597 11C5.34597 9.50046 5.94166 8.06234 7.002 7.002ZM17.908 6.188C18.0381 6.06527 18.1423 5.91768 18.2143 5.75397C18.2863 5.59027 18.3248 5.41377 18.3274 5.23493C18.33 5.05609 18.2967 4.87855 18.2295 4.71281C18.1622 4.54707 18.0624 4.39651 17.936 4.27004C17.8095 4.14357 17.6589 4.04376 17.4932 3.97652C17.3275 3.90928 17.1499 3.87598 16.9711 3.87858C16.7922 3.88119 16.6157 3.91965 16.452 3.9917C16.2883 4.06374 16.1407 4.1679 16.018 4.298C15.7793 4.55103 15.6486 4.88712 15.6537 5.23493C15.6588 5.58274 15.7992 5.91488 16.0452 6.16084C16.2911 6.40681 16.6233 6.54723 16.9711 6.5523C17.3189 6.55737 17.655 6.42669 17.908 6.188Z"
      fill="currentColor"
    />
  </svg>
);

const ScrollDown = () => (
  <svg
    width="72"
    height="24"
    viewBox="0 0 72 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L36.8793 22L70 2"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.13177 10.263C6.27036 10.2628 7.37615 9.88161 8.27305 9.18024L11.093 12L12 11.093L9.18009 8.27325C9.88186 7.37631 10.2633 6.27033 10.2635 5.13149C10.2635 2.30212 7.9613 0 5.13177 0C2.30224 0 0 2.30212 0 5.13149C0 7.96087 2.30224 10.263 5.13177 10.263ZM5.13177 1.28287C7.2544 1.28287 8.9806 3.00898 8.9806 5.13149C8.9806 7.25401 7.2544 8.98012 5.13177 8.98012C3.00914 8.98012 1.28294 7.25401 1.28294 5.13149C1.28294 3.00898 3.00914 1.28287 5.13177 1.28287Z"
      fill="currentColor"
    />
  </svg>
);

const Playbtn = () => (
  <svg
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28.5" cy="28.6139" r="28" fill="white" fillOpacity="0.3" />
    <path
      d="M19.0738 11.6555C19.0738 10.8857 19.9072 10.4045 20.5738 10.7894L47.3441 26.2453C48.0108 26.6302 48.0108 27.5924 47.3441 27.9773L20.5739 43.4331C19.9072 43.818 19.0738 43.3369 19.0738 42.5671L19.0738 11.6555Z"
      fill="white"
      fillOpacity="0.7"
    />
  </svg>
);

const SlideArrowLeft = () => (
  <svg
    width="18"
    height="30"
    viewBox="0 0 18 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.5 1.5L3 15L16.5 28.5" stroke="white" strokeWidth="3" />
  </svg>
);
const SlideArrowRight = () => (
  <svg
    width="18"
    height="30"
    viewBox="0 0 18 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.5 1.5L15 15L1.5 28.5" stroke="white" strokeWidth="3" />
  </svg>
);

const RightArrowCircle = () => (
  <svg
    width="98"
    height="98"
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle r="48.5" transform="matrix(-1 0 0 1 49 49)" stroke="white" />
    <path
      d="M73 49H24M24 49L42 31M24 49L42 67"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);
const LeftArrowCircle = () => (
  <svg
    width="98"
    height="98"
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="49" cy="49" r="48.5" stroke="white" />
    <path
      d="M25 49H74M74 49L56 31M74 49L56 67"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);
export {
  vieLogo,
  iphone,
  mac,
  mobileProject,
  websiteProject,
  BlockChain,
  sale,
  videoCall,
  mobileEcomerce,
  slide1,
  slide2,
  slide3,
  slide4,
  fulfill,
  Zaloicon,
  Facebookicon,
  Tiktokicon,
  Instaicon,
  ScrollDown,
  SearchIcon,
  Playbtn,
  SlideArrowLeft,
  SlideArrowRight,
  RightArrowCircle,
  LeftArrowCircle,
};
